<script>
	import { fade } from 'svelte/transition';
	import { topNavigationVisible } from '../share/stores';
</script>

<div>
	<div class="icon" class:open={$topNavigationVisible}>
		<span></span>
		<span></span>
		<span></span>
		<span></span>
	</div>
	<span>
		{#if $topNavigationVisible}
			<p class="visible--desktop" transition:fade>schließen</p>
		{:else}
			<p class="visible--desktop" transition:fade>Menu</p>
		{/if}
	</span>
</div>

<style lang="scss">
	@import "../style/variables";
	@import "../style/mixins";

	.icon {
		width: 28px;
		height: 20px;
		transform: rotate(0deg);
		transition: .5s ease-in-out;
		float: left;
		--height: 20%;
		flex: auto 0 1;
		margin: auto;

		span {
			display: block;
			position: absolute;
			height: var(--height);
			width: 100%;
			background: black;
			opacity: 1;
			left: 0;
			transform: rotate(0deg);
			transition: .25s ease-in-out;

			&:nth-child(1) {
				top: 0;
			}

			&:nth-child(2),
			&:nth-child(3) {
				top: calc((100% - var(--height)) / 2);
			}

			&:nth-child(4) {
				top: calc(100% - var(--height));
			}
		}

		&.open {
			span {
				&:nth-child(1) {
					top: calc((100% - var(--height)) / 2);
					width: 0;
					left: 50%;
				}

				&:nth-child(2) {
					transform: rotate(45deg);
				}

				&:nth-child(3) {
					transform: rotate(-45deg);
				}

				&:nth-child(4) {
					top: calc((100% - var(--height)) / 2);
					width: 0;
					left: 50%;
				}
			}
		}
	}

	span {
		flex: auto;
		height: auto;
		display: flex;
		align-items: center;
	}

	p {
		position: absolute;
		cursor: pointer;

		&.visible--desktop {
			display: none;
			
			@include for-tablet-landscape-up {
				display: block;
			}
		}
	}
</style>
